<template>
  <div>
    <el-button type="primary" class="addBtn" @click="addVideo">上传短视频</el-button>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column type="index" align="center" prop="date" label="编号" width="180"></el-table-column>
      <el-table-column prop="logo" align="center" label="视频封面" width="250">
        <template slot-scope="scope">
          <img :src="scope.row.logo" style="width:94px;height:94px;" alt />
        </template>
      </el-table-column>
      <el-table-column prop="goodName" align="center" label="关联商品"></el-table-column>
      <el-table-column prop="createTime" align="center" label="上传时间">
        <template  slot-scope="scope">
          {{rebuildTime(scope.row.createTime)}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="250">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="text"
            style="color:red"
            @click="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="pageFn()"
      layout="prev, pager, next"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      :total="count"
      style="margin-top:20px; position:relative; left:45%;"
    ></el-pagination>
  </div>
</template>

<script>
import { getVideoList, delVideo } from "@/api/goods";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      tableData: [],
      count: 10,
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    ...mapGetters(["chooseCompany", "companyList", "mchId"]),
  },
  mounted() {
    this.getList();
  },
  methods: {
    addVideo() {
      this.$router.push({ path: "/main/videoShop/addVideo" });
    },
    getList() {
      let mchId = this.chooseCompany.id;
      getVideoList({
        mchId: mchId,
        page: this.currentPage,
        pageCount: this.pageSize,
      }).then((res) => {
        this.tableData = res.data.list;
        this.count = res.data.count;
      });
    },
    pageFn() {
      this.getList();
    },
    handleEdit(index, item) {
      this.$router.push({
        path: "/main/videoShop/addVideo",
        query: {
          name: "张三",
          goodId: item.goodId,
          goodVideo: item.goodVideo,
          goodName: item.goodName,
          logo: item.logo,
          price: item.price,
          employeePrice: item.employeePrice,
          desc: item.desc,
        },
      });
    },
    handleDelete(index, item) {
      let that = this;
      delVideo(item.goodId).then((res) => {
        if (res.code == 1) {
          that.getList();
          this.$message({
            message: "删除成功",
            type: "success",
          });
        }
      });
    },
    rebuildTime: function(time) {
			const now = new Date()
			const date = new Date(Number(time)),
				Y = date.getFullYear(),
				M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1),
				D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()),
				h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()),
				m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
			const dateTimestamp = date.getTime()
			return String(Y).concat('年', M, '月', D, '日 ', h, ':', m)
		},
  },
};
</script>

<style lang="scss" scoped>
.addBtn {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/videoShop/videoShop.vue